import {
  Box,
  Button,
  Flex,
  IMAGE_PREVIEW_BUTTON_DEFAULT_WIDTH,
  ImagePreviewButton,
} from '@/components';
import { useMessage } from '@/providers';
import { DownloadOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

import type { AttachmentBaseModel } from '../_models/attachment';
import { downloadAttachment } from '../_utils/downloader';
import { AttachmentNameWithOpenButton } from './AttachmentNameWithOpenButton';

type Props = {
  attachment: z.infer<typeof AttachmentBaseModel>;
};

export const UploadedAttachment: FC<Props> = ({ attachment }) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const onClickDownload = async () => {
    try {
      await downloadAttachment(attachment);
    } catch {
      await openMessage('error', t('error-message-file-download-failed'));
    }
  };

  return (
    <Flex align="center" justify="space-between" gap={1}>
      <AttachmentNameWithOpenButton
        name={attachment.fileName}
        weight="regular"
        src={attachment.url ?? undefined}
        width="62%"
      />

      <Flex align="center" justify="flex-end" flex={1}>
        <Button
          type="text"
          onClick={onClickDownload}
          icon={<DownloadOutlined />}
          size="small"
        />
        {attachment.url !== null &&
        attachment.fileContentType.startsWith('image') ? (
          <ImagePreviewButton previewURL={attachment.url} />
        ) : (
          <Box width={IMAGE_PREVIEW_BUTTON_DEFAULT_WIDTH} />
        )}
      </Flex>
    </Flex>
  );
};
